var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-3" },
    _vm._l(_vm.notifications, function (notificator) {
      return _c(
        "base-notificator",
        {
          key: notificator.orderCommunicationID,
          attrs: { type: "warning" },
          on: {
            close: function ($event) {
              return _vm.onExtraChargeNotificatorClose(
                notificator.orderCommunicationID
              )
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "_flexcol _gap-3" },
            [
              _c(
                "localize",
                {
                  attrs: {
                    resource:
                      _vm.Resources.YourPledge.YourPledgeExtraChargeDescription,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "_tdu",
                      attrs: { "format-key": "0" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onRequestRefundClick.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.Resources.YourPledge
                            .YourPledgeExtraChargeRequestRefundLabel
                        )
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("base-collapsible", {
                attrs: {
                  "is-expanded": notificator.isExpanded,
                  rounded: false,
                  "data-qa": "your-pledge:ExtraChargeCreatorMessage",
                },
                on: { toggle: _vm.onToggleCollapsible },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "trigger",
                      fn: function ({ isExpanded }) {
                        return [
                          _c("base-icon", {
                            attrs: {
                              name: isExpanded ? "chevron-up" : "chevron-down",
                            },
                          }),
                          _vm._v(" "),
                          !isExpanded
                            ? [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.Resources.YourPledge
                                        .YourPledgeExtraChargeShowCreatorMessageLabel
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.Resources.YourPledge
                                        .YourPledgeExtraChargeHideCreatorMessageLabel
                                    ) +
                                    "\n                    "
                                ),
                              ],
                        ]
                      },
                    },
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "gfu-richtext" }, [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(notificator.text) },
                            }),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }